import { FormControl, FormGroup } from '@angular/forms';
import { ApprovalObject } from './../InboxInterfaces/approvalObject';
import { LayoutService } from './../../layout.service';
import { InboxObject } from './../InboxInterfaces/InboxFolder';
import { MessageDetail } from '../InboxInterfaces/messageDetail';
import {
  Component,
  HostListener,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InboxService } from 'src/app/services/InboxService.service';
import { toNumber } from 'ng-zorro-antd/core/util';
import { InboxFolder } from '../InboxInterfaces/InboxFolder';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { InboxListComponent } from '../inboxList/inboxList.component';
import { NzDrawerRef, NzDrawerService } from 'ng-zorro-antd/drawer';
import { Subscription } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { RecordPageComponent } from '../../record-page/record-page.component';
import { ApprovalDecisionDialogComponent } from '@app/layout/general/approval-decision-dialog/approval-decision-dialog.component';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-MessageDetails',
  templateUrl: './MessageDetails.component.html',
  styleUrls: ['./MessageDetails.component.less'],
})
export class MessageDetailsComponent implements OnInit {
  @ViewChild('ApprovaldrawerTemplate', { static: false })
  drawerTemplate?: TemplateRef<{
    $implicit: { value: string };
    drawerRef: NzDrawerRef<string>;
  }>;
  @Input() value = '';
  @Input() isDrawer = false;
  isLoading = true;
  columns: string[] = [];
  RecordsCount = 0;
  RecordsArray = [];
  messageId: string;
  Folders: InboxFolder[];
  MessageDetail!: MessageDetail;
  folderObject: InboxFolder;
  approvalForm: FormGroup;
  messageIdSubscription: Subscription;
  sharedMessageId: string;
  ApprovalMessage: ApprovalObject;
  NowFolder: InboxFolder;
  public innerWidth: any;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }
  constructor(
    private inboxService: InboxService,
    private routes: ActivatedRoute,
    private notification: NzNotificationService,

    private layoutService: LayoutService,
    private drawerService: NzDrawerService
  ) {
    this.approvalForm = new FormGroup({
      AppRemark: new FormControl(),
      AppStatus: new FormControl(),
    });
    this.innerWidth = window.innerWidth;
  }

  ngOnInit() {
    if (this.isDrawer === true) {
      this.isLoading = true;
      this.columns = [];
      this.inboxService
        .getMessageDetail(toNumber(this.value))
        .subscribe((dat) => {
          this.initMessageDetails(dat);
          this.messageId = this.value;
        });
    } else {
      this.routes.params
        .pipe(
          switchMap((param) => {
            this.isLoading = true;
            this.messageId = param.id;
            this.inboxService.changeMessageId(param.id);
            return this.inboxService.getMessageDetail(toNumber(this.messageId));
          })
        )
        .subscribe(
          (dat) => {
            this.columns = [];
            this.initMessageDetails(dat);
          },
          (error) => {
            console.log(error);
          }
        );
    }
    this.routes.queryParams.subscribe((qParams) => {
      let QueryFolderName: string = qParams.folder;
      if (!qParams.folder) {
        QueryFolderName = 'inbox';
      }
      this.inboxService.getInboxFolders().subscribe((data: InboxObject) => {
        this.NowFolder = data.rowsArray.find(
          (x) => x.Name.toLowerCase() === QueryFolderName.toLowerCase()
        );
        this.Folders = data.rowsArray.filter(
          (x) => x.Name.toLowerCase() !== this.NowFolder.Name.toLowerCase()
        );
      });
    });
  }

  /*openTemplate(): void {
    const drawerRef = this.drawerService.create({
      nzTitle: 'Approval',
      nzContent: this.drawerTemplate,
      nzWrapClassName: 'drawer-size-2x',
      nzContentParams: {
        message: this.ApprovalMessage,
      },
    });
  }*/

  openDraftDocument(docEntry, immediately = false) {
    RecordPageComponent.openRecordPage(this.drawerService, {
      actionType: 'View',
      drawerTitle: 'View Details',
      inDrawer: true,
      moduleId: immediately ? 59 : this.ApprovalMessage.ModuleId,
      parentComponent: this,
      recordId: docEntry,
      recordModel: undefined,
      fromDraft: immediately ? false : (this.ApprovalMessage.ModuleId != 59 && this.ApprovalMessage.IsDraft == 'Y')
    });
  }

  openApproval(docEntry: string) {
    const keys = docEntry.split(' ');

    ApprovalDecisionDialogComponent.openTemplate(
      keys[0],
      'INBOX',
      this.drawerService,
      this.layoutService
    );

    /*this.layoutService
      .executeQuery(2191, {
        'Documents.DocEntry': keys[0],
      })
      .subscribe((data) => {
        this.ApprovalMessage = data[0];
        this.approvalForm
          .get('AppStatus')
          .setValue(this.ApprovalMessage.AppStatus);
          this.approvalForm
          .get('AppRemark')
          .setValue(this.ApprovalMessage.AppRemark);
        this.openTemplate();
      });*/
  }

  onApprovalSubmit() {
    this.inboxService
      .changeApprovalStatus(
        this.ApprovalMessage.WddCode,
        this.approvalForm.get('AppStatus').value,
        this.approvalForm.get('AppRemark').value
      )
      .subscribe((d: any) => {
        if (d.Has_Error) {
          this.notification.create('error', '', d.Error_Message);
        } else {
          this.notification.create(
            'success',
            'Status changed',
            'Approval Status changed successfuly'
          );
        }
      });
  }

  removeDateAddedString(str: string) {
    const newSTR = str.replace('/Date(', '').replace(')/', '');
    return newSTR;
  }

  initMessageDetails(data: MessageDetail) {
    this.MessageDetail = data;
    if (data.MsgColValues.length > 0) {
      for (const column of this.MessageDetail.MsgColValues) {
        this.columns.push(column.ColumnName);
      }
      this.RecordsCount = this.MessageDetail.MsgColValues[0].ColValues.length;
      this.RecordsArray = Array(this.RecordsCount)
        .fill(0)
        .map((x, i) => i);
    }
    this.MessageDetail.UserText = this.MessageDetail.UserText.replace(
      /\r/gi,
      '<br>'
    );

    this.isLoading = false;
  }

  MoveMessage(MessageId: string, Folder: string) {
    this.inboxService.MoveMessageToFolder(MessageId, Folder).subscribe(() => {
      // tslint:disable-next-line: no-non-null-assertion
      this.folderObject = this.Folders.find((x) => x.Code === Folder)!;
      this.inboxService.updateInboxEmitter.emit();
      this.notification.blank(
        'Message Moved',
        'The message moved successfuly to ' + this.folderObject.Name,
        { nzDuration: 500 }
      );
    });
  }
}
